export enum NotificationType {
  quote = 'quote',
  clickToPay = 'clickToPay',
  achSetup = 'achSetup',
  acceptTerms = 'acceptTerms',
  scanLicense = 'scanLicense',
}

export type SendQuoteRequest = {
  type: NotificationType.quote;
  orderId: number;
  emailOverride?: string;
};

export type SendClickToPayRequest = {
  type: NotificationType.clickToPay;
  invoiceId: string;
  emailOverride?: string;
};

export type SendAchSetupRequest = {
  type: NotificationType.achSetup;
  userId: number;
  emailOverride?: string;
};

export type SendAcceptTermsRequest = {
  type: NotificationType.acceptTerms;
  format: 'email' | 'sms';
  orderId: number;
};

export type SendScanLicenseRequest = {
  type: NotificationType.scanLicense;
  format: 'sms';
  orderId: number;
  userId: number;
};

export type NotificationRequest =
  | SendQuoteRequest
  | SendClickToPayRequest
  | SendAchSetupRequest
  | SendAcceptTermsRequest
  | SendScanLicenseRequest;
